<div class="container-fluid p-0 m-0 h-100">
  <div class="row p-0 m-0 h-100">
    <div class="col-2 d-flex p-0">
      <div *ngIf="fieldsIntersected" class="fields-container position-relative w-100">
        <!-- LEFT PANEL -->
        <div class="text-container">
          <span class="text-title">List Fields</span>
        </div>
        <div class="search">
          <input
            type="text"
            id="searchField"
            name="searchField"
            [(ngModel)]="search"
            [placeholder]="'Search...'"
            class="input-app input-search"
            (ngModelChange)="searchFields($event)"
          />
        </div>
        <div class="cards" id="field-card-container">
          <div
            class="card  mg-field-builder"
            [attr.data-name]="field.name"
            [attr.data-id]="field.id"
            *ngFor="let field of intersectedFields | search : search"
            (click)="selectField(field)"
            [ngClass]="{ 'card-selected': selectedField?.id === field.id }"
          >
            <div class="content">
              <span class="name" matTooltip="{{ field.name }}">
                {{
                  field.name.length > 17
                    ? (field.name | slice : 0 : 17) + "..."
                    : field.name
                }}
              </span>
              <div class="field-detail d-flex justify-content-between">
                <span class="type">{{ field.type }} </span>
                <span *ngIf="field.required" class="required"> Required </span>
                <!-- <span class="date">
                  Last date edited: {{ form.last_update_time | date : "medium" }}
                </span> -->
              </div>
            </div>
            <div class="mg-field-move-container">
              <mat-icon class="mg-field-move">open_with</mat-icon>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-10 d-flex p-0 justify-content-center">
      <div class="position-relative w-100">
        <!-- MAIN  -->
        <div class="general">          
          <!-- BUTTONS -->    
          <div class="buttons">
            <button *ngIf="currentPage" [ngClass]="{'mg-button-selected': isPreview}"
              (click)="previewLayout()" class="btn-style flex justify-content-center align-items-center me-1">
              <span [ngClass]="{'mg-button-icon-selected': isPreview}" class="material-symbols-outlined icon-style">
                visibility
              </span>
              <span [ngClass]="{'mg-button-icon-selected': isPreview}" class="text-sm">Preview</span>
            </button>           
            <button (click)="addPage()" class="btn-style flex justify-content-center align-items-center me-1">
              <span class="material-symbols-outlined icon-style">
                note_add
              </span>
              <span class="text-sm">Page</span>
            </button>            
            <button *ngIf="changeDetected" (click)="save()" [ngClass]="{ changes: changeDetected }" class="btn-style flex justify-content-center align-items-center me-1">
              <span class="material-symbols-outlined icon-style">
                save
              </span>
              <span class="text-sm">Save</span>
            </button>
            <button *ngIf="changeDetected" (click)="cancelEditLayout()" class="btn-style flex justify-content-center align-items-center me-1">
              <span class="material-symbols-outlined icon-style">
                cancel
              </span>
              <span class="text-sm">Cancel</span>
            </button>            
            <!-- <button style="margin-left: auto;" class="btn-style flex justify-content-center align-items-center me-1">
              <span class="material-symbols-outlined icon-style">
                dns
              </span>
              <span class="text-sm">Add Field</span>
            </button> -->
          </div>
        </div>
            
        <div class="container-body">
          <!-- NO PAGES -->
          <div class="mg-no-page-container" *ngIf="!currentPage || editedLayout.length == 0">
            <span class="material-symbols-outlined mg-no-page-icon"
            (click)="addPage()"
            >
              list_alt_add
              </span>
            <!--  <mat-icon class="">list_alt_add</mat-icon> -->
            <span class="mg-no-page-text">No pages found. Please create one</span>
          </div>
          
          <!-- PAGES -->
          <div class="mg-page-wrapper">
            <div class="mg-page-container" *ngIf="currentPage && editedLayout">
              <ng-container *ngFor="let page of editedLayout; index as i">
                <div class="mg-page-text-container">
                  <span (click)="setCurrentPage(page.id, i)" class="mg-page-title" [ngClass]="{'mg-page-selected': this.currentPage.id === page.id}">{{page.name}} ({{i+1}})</span>
                  <mat-icon (click)="deletePage(i)" *ngIf="this.currentPage.id === page.id" class="mg-delete-page">delete</mat-icon>
                </div>
                <div *ngIf="i < editedLayout.length - 1" class="mg-page-text-container">
                  <span class="mg-page-title">|</span>
                </div>
              </ng-container>
            </div>
          </div>

          <!-- NO ROW -->
          <div class="mg-no-page-container" *ngIf="currentPage && currentPage.rows?.length == 0">
            <span (click)="insertRow()" class="material-symbols-outlined mg-no-page-icon">
              view_column_2
              </span>
            <!--  <mat-icon class="">list_alt_add</mat-icon> -->
            <span class="mg-no-page-text">No rows found. Please create one</span>
          </div>

          <!-- LAYOUT  -->          
          <div [ngClass]="{'hide': this.isPreview}" *ngIf="editedLayout && currentPage" class="mg-layout-container">
            <div class="mg-page-builder" *ngFor="let page of editedLayout; index as pageIndex" [attr.data-pos]="pageIndex">               
              <!-- ROW SECTION-->
              <div class="mg-row-wrapper" [ngClass]="{'hide': this.currentPage.id !== page.id}">

                <div class="mg-row-builder row" *ngFor="let row of page.rows">
                  <!-- ROW TOP-->                  
                  <!-- COL SECTION-->
                  <div class="mg-col-wrapper">

                    <div class="mg-col-builder col" *ngFor="let col of row.columns">
                      <!-- COL CENTER-->
                      <div class="mg-col-center-action-container mg-col-actions">
                        <div class="card mg-field-builder" *ngFor="let field of col.fields; index as fieldIndex" [attr.data-name]="field.name">
                          <div class="content">
                            <span class="name" matTooltip="{{ field.name }}">
                              {{
                                field.name.length > 17
                                  ? (field.name | slice : 0 : 17) + "..."
                                  : field.name
                              }}
                            </span>
                            <div
                              class="field-detail d-flex justify-content-between"
                            >
                              <span class="type">{{ field.type }} </span>
                            </div>
                          </div>
                          <div class="mg-field-move-container">
                            <mat-icon class="mg-field-move">open_with</mat-icon>
                          </div>
                        </div>
                      </div>
                      <!-- COL RIGHT-->
                    </div>
                  </div>
                  <!-- ROW BOTTOM--> 
                </div>

              </div>
            </div>
          </div>

          <!-- PREVIEW  -->
          <div [ngClass]="{'hide': !this.isPreview}">
            <mng-fill-form [inputProperties]="formOptions"></mng-fill-form>
          </div>

        </div>
          
      </div>

    </div>
  </div>  

</div>

<!--LOADING-->
<!-- <div *ngIf="loadingLayout || (loadingFields && !fieldsIntersected)" class="loading-style fields-container position-relative w-100">
  <app-loading-spinner></app-loading-spinner>
</div> -->
<!-- <div *ngIf="updatingLayout || loadingLayout || (loadingFields && !fieldsIntersected)" class="loading-style fields-container position-relative w-100">
  <app-loading-spinner></app-loading-spinner>
</div> -->

<!-- <div *ngIf="updatingLayout || loadingLayout || (loadingFields && !fieldsIntersected)" class="loading-style">
  <app-loading-spinner></app-loading-spinner>
</div> -->